<template>
  <div class="news-list">
    <BasePage mode="list">
      <div slot="toolBar">
        <div style="display: flex;justify-content: space-between">
          <div style="">
            <el-button
              v-access:add
              icon="el-icon-plus"
              size="small"
              @click="btnAdd"
              v-if="activeName == 'library'"
              :disabled="isloading"
              >新增</el-button
            >
          </div>
          <div style="display: flex">
            <el-input
              style="width: 290px;margin-right: 10px;"
              v-model="searchModel.searchKey"
              clearable
              :placeholder="placeholder"
            />
            <div style="margin-left: 10px">
              <el-button
              size="small"
              icon="el-icon-search"
              type="danger"
              @click="btnSearch"
              >查询</el-button
            >
            </div>
          </div>
        </div>
      </div>

      <div>
        <el-tabs
          v-model="activeName"
          type="border-card"
          @tab-click="handleTabsClick"
        >
          <el-tab-pane label="救护员培训报名" name="lifeGuard">
            <el-table
              border
              hightlight-current-row
              style="width: 100%"
              :header-cell-class-name="headerRow"
              :data="lifeGuardModel"
              :max-height="tableMaxHeight()"
              v-loading="isloading"
            >
              <el-table-column
                prop="Title"
                label="培训主题"
                :show-overflow-tooltip="true"
              ></el-table-column>
              <el-table-column
                prop="SumNum"
                label="报名总人数"
                width="100"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="Address"
                label="培训地址"
                :show-overflow-tooltip="true"
                width="400"
              ></el-table-column>
              <!-- <el-table-column
                prop="StartTime"
                label="培训时间"
                width="140"
                align="center"
              >
                <template slot-scope="scope">
                  {{ (scope.row.StartTime * 1000) | formatDate }}
                </template>
              </el-table-column> -->
              <!-- <el-table-column
                prop="Status"
                label="培训状态"
                align="center"
                :formatter="formatterStatus"
                width="100"
              ></el-table-column> -->
              <el-table-column label="操作" width="150" align="center">
                <template slot-scope="scope">
                  <el-button
                    v-access:read
                    @click="gotoLifeGuard(scope.row)"
                    type="text"
                    size="mini"
                    >详情</el-button
                  >
                  <el-button
                    v-access:modify
                    @click="innerExport(scope.row)"
                    type="text"
                    size="mini"
                    >导出</el-button
                  >
                  <el-button
                    v-access:modify
                    @click="gotoClassList(scope.row)"
                    type="text"
                    size="mini"
                    >分班</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
          <el-tab-pane label="收费讲座报名" name="groupLecture">
            <el-table
              border
              hightlight-current-row
              style="width: 100%"
              :header-cell-class-name="headerRow"
              :data="groupLectureModel"
              :max-height="tableMaxHeight()"
              v-loading="isloading"
            >
              <el-table-column
                prop="Name"
                label="机构名称"
                fixed
                width="300"
                :show-overflow-tooltip="true"
              ></el-table-column>
              <el-table-column
                prop="TrainTitle"
                label="讲座名称"
                width="250"
                align="left"
              ></el-table-column>
              <el-table-column
                prop="CompanyNature"
                label="企业性质"
                width="120"
                align="center"
                :formatter="CompanyNature"
              ></el-table-column>
              <el-table-column
                prop="ContactUser"
                label="联系人"
                width="110"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="Phone"
                label="手机号码"
                width="120"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="SignUpNum"
                label="报名总人数"
                width="120"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="IsVenue"
                label="是否自行提供场地"
                width="160"
                align="center"
                :formatter="IsVenue"
              ></el-table-column>
              <el-table-column
                prop="TrainTime"
                label="培训时间"
                width="140"
                align="center"
              >
                <template slot-scope="scope">
                  {{ (scope.row.TrainTime * 1000) | formatDate }}
                </template>
              </el-table-column>
              <el-table-column label="操作" width="150" align="center">
                <template slot-scope="scope">
                  <el-button
                    v-access:read
                    @click="innerDetail(scope.row)"
                    type="text"
                    size="mini"
                    >详情</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
          <el-tab-pane label="公益讲座报名" name="personalLecture">
            <el-table
              border
              hightlight-current-row
              :header-cell-class-name="headerRow"
              :data="personalLectureModel"
              :max-height="tableMaxHeight()"
              v-loading="isloading"
            >
              <el-table-column
                prop="Name"
                label="姓名"
                align="left"
              ></el-table-column>
              <el-table-column
                prop="TrainTitle"
                label="讲座名称"
                width="250"
                align="left"
              ></el-table-column>
              <el-table-column
                prop="LectureTime"
                label="培训时间"
                width="140"
                align="center"
              >
                <template slot-scope="scope">
                  {{ (scope.row.LectureTime * 1000) | formatDate }}
                </template>
              </el-table-column>
              <el-table-column
                prop="MemberType"
                label="账号类型"
                width="100"
                align="center"
                :formatter="MemberType"
              ></el-table-column>
              <el-table-column
                prop="SignUpNum"
                label="人数"
                width="80"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="Phone"
                label="手机号码"
                width="120"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="IsAttended"
                label="是否到场"
                width="100"
                align="center"
                :formatter="IsAttended"
              ></el-table-column>
              <el-table-column label="操作" width="120" align="center">
                <template slot-scope="scope">
                  <el-button
                    v-access:read
                    @click="innerDetail(scope.row)"
                    type="text"
                    size="mini"
                    >详情</el-button
                  >
                  <el-button
                    v-access:modify
                    v-if="scope.row.IsAttended != 1"
                    @click="innerUpdateIsAttended(scope.row)"
                    type="text"
                    size="mini"
                    >确认</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
          <el-tab-pane label="体验馆预约报名" name="library">
            <el-table
              border
              hightlight-current-row
              :header-cell-class-name="headerRow"
              :data="libraryModel"
              :max-height="tableMaxHeight()"
              v-loading="isloading"
            >
              <el-table-column prop="Title" label="标题"></el-table-column>
              <el-table-column label="开放时间" width="140" align="center">
                <template slot-scope="scope">
                  {{ (scope.row.OpenTime * 1000) | formatDate }}
                </template>
              </el-table-column>
              <el-table-column
                prop="TrainTitle"
                label="活动名称"
                width="250"
                align="left"
                :show-overflow-tooltip="true"
              ></el-table-column>

              <el-table-column label="操作" width="150" align="center">
                <template slot-scope="scope">
                  <el-button
                    v-access:modify
                    @click="innerEdit(scope.row)"
                    type="text"
                    size="mini"
                    >编辑</el-button
                  >
                  <el-button
                    v-access:read
                    @click="innerDetail(scope.row)"
                    type="text"
                    size="mini"
                    >详情</el-button
                  >
                  <el-button
                    v-access:modify
                    @click="cancel(scope.row)"
                    type="text"
                    size="mini"
                    >取消预约</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
        </el-tabs>
        <div class="pagination-wapper">
          <OfPagination
            :total="total"
            :pageSize="pageSize"
            :currentPage="currentPage"
            @onSizeChange="handleSizeChange"
            @onCurrentChange="handleCurrentChange"
          ></OfPagination>
        </div>
      </div>
    </BasePage>
    <ModuleDetail_lifeGuard
      v-if="formVisible_lifeGuard"
      :id="id"
      :formTitle="formTitle"
      @formCallBack="formCallBack"
    ></ModuleDetail_lifeGuard>
    <ModuleDetail_groupLecture
      v-if="formVisible_groupLecture"
      :dataForm="formData"
      :formTitle="formTitle"
      @formCallBack="formCallBack"
    ></ModuleDetail_groupLecture>
    <ModuleDetail_personalLecture
      v-if="formVisible_personalLecture"
      :dataForm="formData"
      :formTitle="formTitle"
      @formCallBack="formCallBack"
    ></ModuleDetail_personalLecture>
    <ModuleEdit_library
      v-if="formVisible_library"
      :dataForm="formData"
      :formTitle="formTitle"
      @formCallBack="formCallBack"
    ></ModuleEdit_library>
    <ModuleDetail_library
      v-if="formVisible_library_detail"
      :dataForm="formData"
      :formTitle="formTitle"
      @formCallBack="formCallBack"
    ></ModuleDetail_library>
    <ModuleDetail_class
      v-if="formVisible_class_detail"
      :dataForm="formData"
      :formTitle="formTitle"
      @formCallBack="formCallBack"
    ></ModuleDetail_class>
  </div>
</template>

<script>
import BasePage from "@/components/base/of_page/of_page";
import OfSearch from "@/components/controls/of_search/of_search";
import ModuleDetail_lifeGuard from "@/modules/zjrc/pages/train/trainapply/detail_lifeGuard";
import ModuleDetail_groupLecture from "@/modules/zjrc/pages/train/trainapply/detail_groupLecture";
import ModuleDetail_personalLecture from "@/modules/zjrc/pages/train/trainapply/detail_personalLecture";
import ModuleEdit_library from "@/modules/zjrc/pages/train/trainapply/edit_Library";
import ModuleDetail_library from "@/modules/zjrc/pages/train/trainapply/detail_Library";
import ModuleDetail_class from "@/modules/zjrc/pages/train/trainapply/detail_class";
import OfPagination from "@/components/controls/of_pagination/of_pagination";
import { mapGetters } from "vuex";
import { saveAs } from "file-saver";
import api from "@/modules/zjrc/api";

export default {
  name: "list",
  data() {
    return {
      headerRow: "header-row",
      isloading: false,
      listData: [],
      formVisible_lifeGuard: false,
      formVisible_groupLecture: false,
      formVisible_personalLecture: false,
      formVisible_library: false,
      formVisible_library_detail: false,
      formVisible_class_detail: false,
      formTitle: "",
      formData: {},

      total: 0,
      currentPage: 1,
      pageSize: 15,
      searchModel: { searchKey: "" },

      placeholder: "请输入培训主题",

      activeName: "lifeGuard",
      type: 1,
      applyType: 1,
      lectureType: 0,

      lifeGuardModel: [],
      groupLectureModel: [],
      personalLectureModel: [],
      libraryModel: [],
      id: "", //详情Id
    };
  },
  computed: {
    ...mapGetters(["GetCurrentUserInfo"]),
  },
  mounted() {
    this.loadData();
  },
  methods: {
    //跳转到分班页面
    gotoClassList(item) {
      this.$router.push({
        path: "/zjrc/trainapply/classList",
        query: { Id: item.Id, minPeople: item.MinimumPeople },
      });
    },
    //初始化救护员培训报名数据
    loadData() {
      this.isloading = true;
      let params = {
        SearchKey: this.searchModel.searchKey,
        PageIndex: this.currentPage,
        PageSize: this.pageSize,
      };
      api.QueryLifeGuard(params).then((rep) => {
        if (rep.data.Code === 0) {
          this.total = rep.data.Data.total;
          var listData = rep.data.Data.rows;
        }
        this.lifeGuardModel = listData;
        this.isloading = false;
      });
    },
    //初始化团体讲座报名数据
    loadLectureData() {
      this.isloading = true;
      let params = {
        pageIndex: this.currentPage,
        pageSize: this.pageSize,
        lectureType: this.lectureType,
        SearchKey: this.searchModel.searchKey,
      };
      api.QueryLectureApplyByType(params).then((rep) => {
        if (rep.data.Code === 0) {
          this.total = rep.data.Data.total;
          if (this.lectureType == 1) {
            this.groupLectureModel = rep.data.Data.rows;
          } else {
            this.personalLectureModel = rep.data.Data.rows;
          }
        }
        this.isloading = false;
      });
    },
    //加载体验馆数据
    loadLibraryData() {
      this.isloading = true;
      let params = {
        pageIndex: this.currentPage,
        pageSize: this.pageSize,
        SearchKey: this.searchModel.searchKey,
      };
      api.QueryLibraryPeriods(params).then((rep) => {
        if (rep.data.Code === 0) {
          this.total = rep.data.Data.total;
          this.libraryModel = rep.data.Data.rows;
          this.isloading = false;
        }
      });
    },
    formCallBack(data) {
      this.formVisible_lifeGuard = false;
      this.formVisible_groupLecture = false;
      this.formVisible_personalLecture = false;
      this.formVisible_library = false;
      this.formVisible_library_detail = false;
      this.formVisible_class_detail = false;
      if (data) {
        if (data.TrainId != "") {
          this.activeName = "lifeGuard";
          this.loadData();
        } else {
          this.activeName = "library";
          this.loadLibraryData();
        }
        this.currentPage = 1;
      }
    },
    //改变分页大小
    handleSizeChange(val) {
      this.currentPage = 1;
      this.pageSize = val;
      this.loadData();
    },
    //改变当前页码
    handleCurrentChange(val) {
      if (this.total > this.pageSize) {
        this.currentPage = val;
        this.loadData();
      }
    },
    //列表高度
    tableMaxHeight() {
      var clientHeight = window.innerHeight;
      var tableMaxHeight = 0;
      if (clientHeight && clientHeight !== undefined) {
        tableMaxHeight = clientHeight - 363;
      }
      return tableMaxHeight;
    },
    //查询点击事件
    btnSearch() {
      switch (this.activeName) {
        case "lifeGuard":
          this.type = 1;
          this.loadData();
          break;
        case "groupLecture":
          this.lectureType = 1;
          this.loadLectureData();
          break;
        case "personalLecture":
          this.lectureType = 0;
          this.loadLectureData();
          break;
        default:
          this.loadLibraryData();
      }
    },
    //状态
    formatterStatus(item) {
      let now = Date.parse(new Date()) / 1000;
      if (item.DeadLine > now) {
        return "报名中";
      } else if (item.DeadLine < now && item.StartTime > now) {
        return "已截止报名";
      } else if (item.StartTime < now && item.EndTime > now) {
        return "进行中";
      } else {
        return "已结束";
      }
    },
    CompanyNature(rowData) {
      switch (rowData.CompanyNature) {
        case 0:
          return "团体会员";
        case 1:
          return "非团体会员";
        case 2:
          return "盈利性企业";
        case 3:
          return "非盈利性企业（社区/学校/）";
      }
    },
    IsVenue(rowData) {
      return rowData.IsVenue == 0 ? "否" : "是";
    },
    IsAttended(rowData) {
      return rowData.IsAttended == 1 ? "是" : "否";
    },
    MemberType(rowData) {
      return rowData.MemberType === 1 ? "个人" : "团体";
    },
    Sex(rowData) {
      return rowData.Sex == 0 ? "女" : "男";
    },
    //新增
    btnAdd() {
      this.formData = {};
      this.formTitle = "新增体验馆期数";
      this.formVisible_library = true;
    },
    //调转到救护员培训详情
    gotoLifeGuard(rowData) {
      this.$router.push({
        path: "/zjrc/trainapply/detailLifeGuard",
        query: { Id: rowData.Id },
      });
    },
    //详情
    innerDetail(rowData) {
      this.id = rowData.Id;
      this.formData = rowData;
      switch (this.activeName) {
        case "lifeGuard":
          this.formTitle = "救护员培训报名详情";
          this.formVisible_lifeGuard = true;
          break;
        case "groupLecture":
          this.formTitle = "讲座报名详情";
          this.formVisible_groupLecture = true;
          break;
        case "personalLecture":
          this.formTitle = "讲座报名详情";
          this.formVisible_personalLecture = true;
          break;
        default:
          this.formTitle = rowData.Title + "详情";
          this.formVisible_library_detail = true;
      }
    },
    //编辑
    innerEdit(rowData) {
      this.formData = Object.assign({}, rowData);
      this.formData.OpenTime = this.formData.OpenTime * 1000;
      this.formVisible_library = true;
    },
    //导出到Excel
    innerExport(rowData) {
      this.isloading = true;
      saveAs(
        "/api/TrainApply/QueryToExcel?TrainId=" + rowData.Id,
        "救护员培训报详情表.xls"
      );
      this.isloading = false;
    },
    innerClass(rowData) {
      this.formData = rowData;
      this.formTitle = "班级详情";
      this.formVisible_class_detail = true;
    },
    download(data, id) {
      let self = this;
      if (!data) {
        return;
      }
      let url = window.URL.createObjectURL(new Blob([data]));
      let link = document.createElement("a");
      self.imgsrc = url;
      link.style.display = "none";
      link.href = url;
      link.setAttribute("download", id + ".xls");
      document.body.appendChild(link);
      link.click();
    },
    //tab切换
    handleTabsClick(tab, event) {
      this.currentPage = 1;
      switch (tab.name) {
        case "lifeGuard":
          this.type = 1;
          this.loadData();
          break;
        case "groupLecture":
          this.lectureType = 1;
          this.loadLectureData();
          break;
        case "personalLecture":
          this.lectureType = 0;
          this.loadLectureData();
          break;
        default:
          this.loadLibraryData();
      }
    },
    //确认到场
    innerUpdateIsAttended(rowData) {
      this.$confirm("请确认是否到场？", "系统提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let params = { Id: rowData.Id };
        api
          .UpdateLectureIsAttended(params)
          .then((rep) => {
            if (rep.data.Code === 0) {
              this.$message({
                message: "提交成功",
                type: "success",
              });
              this.loadLectureData();
            } else {
              this.$message({
                message: rep.data.Message,
                type: "error",
              });
            }
          })
          .catch((e) => {
            this.isConfirm = false;
            this.$message({
              message: e.toString(),
              type: "error",
            });
          });
      });
    },
    //体验馆预约取消
    cancel(rowData) {
      this.$confirm("请确认是否取消预约？", "系统提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let params = { Periods: rowData.Id };
        api
          .CancelLifeApply(params)
          .then((res) => {
            if (res.data.Code == 0) {
              this.$message({
                message: "取消成功",
                type: "success",
              });
            } else {
              this.$message({
                message: res.data.Message,
                type: "error",
              });
            }
          })
          .catch((e) => {
            this.isConfirm = false;
            this.$message({
              message: e.toString(),
              type: "error",
            });
          });
      });
    },
  },
  components: {
    BasePage,
    OfSearch,
    OfPagination,
    ModuleDetail_lifeGuard,
    ModuleDetail_groupLecture,
    ModuleDetail_personalLecture,
    ModuleEdit_library,
    ModuleDetail_library,
    ModuleDetail_class,
  },
};
</script>

<style scoped>
.list-form {
  padding: 20px;
  /* border-right: solid 1px #efefef; */
  box-sizing: border-box;
  float: left;
  overflow: auto;
}

.el-date-editor >>> .el-input__icon {
  display: none;
}
/* .el-date-editor >>> .el-input__inner {
  padding-left: 10px !important;
} */

.el-select >>> .el-input__inner {
  width: 3rem;
}

/* .el-date-editor >>> .el-input__inner {
  width: 60%;
} */
.el-row >>> .el-date-editor {
  width: 2.5rem !important;
}
</style>
